import { call, put, takeEvery } from "redux-saga/effects";

import {
  ADD_NEW_DEFAULT_ASSIGNMENT,
  DELETE_DEFAULT_ASSIGNMENT,
  GET_DEFAULT_ASSIGNMENTS,
  UPDATE_DEFAULT_ASSIGNMENT,
  UPDATE_DEFAULT_ASSIGNMENT_STATUS
} from "./actionTypes";

import {
  addDefaultAssignmentFail,
  addDefaultAssignmentSuccess,
  deleteDefaultAssignmentFail,
  deleteDefaultAssignmentSuccess,
  getDefaultAssignmentsFail,
  getDefaultAssignmentsSuccess,
  setState,
  updateDefaultAssignmentFail,
  updateDefaultAssignmentSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { defaultAssignments, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchDefaultAssignments({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, defaultAssignments, params.toString());
    yield put(setState(false));
    yield put(getDefaultAssignmentsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getDefaultAssignmentsFail(error));
  }
}

function* updateDefaultAssignment({ payload: assignmentObj }) {
  try {
    const { id, ...rest } = assignmentObj;
    yield call(patchApiCall, `${defaultAssignments}/${id}`, rest);
    const response = yield call(getTable, `${defaultAssignments}/${assignmentObj.id}`);
    yield put(updateDefaultAssignmentSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateDefaultAssignmentFail(error));
    const msg = error?.response?.data?.message;
    toast.error(typeof msg === 'string' ? msg : 'Error al actualizar el registro');
  }
}

function* updateDefaultAssignmentStatus({ payload: assignmentObj }) {
  try {
    yield call(patchApiCall, `${defaultAssignments}/${updateStatus}/${assignmentObj.id}`, { recordStatus: assignmentObj.recordStatus });
    const response = yield call(getTable, `${defaultAssignments}/${assignmentObj.id}`);
    yield put(updateDefaultAssignmentSuccess(response));
  } catch (error) {
    yield put(updateDefaultAssignmentFail(error));
  }
}

function* deleteDefaultAssignment({ payload: assignmentObj }) {
  try {
    yield call(deleteApiCall, `${defaultAssignments}/${assignmentObj.id}`);
    yield put(deleteDefaultAssignmentSuccess(assignmentObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteDefaultAssignmentFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingDefaultAssignment({ payload: assignmentObj }) {
  try {
    const response = yield call(postApiCall, defaultAssignments, assignmentObj);
    yield put(addDefaultAssignmentSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addDefaultAssignmentFail(error));
    const msg = error?.response?.data?.message;
    toast.error(typeof msg === 'string' ? msg : 'Error al agregar el registro');
  }
}

function* defaultAssignmentsSaga() {
  yield takeEvery(GET_DEFAULT_ASSIGNMENTS, fetchDefaultAssignments);
  yield takeEvery(ADD_NEW_DEFAULT_ASSIGNMENT, postingDefaultAssignment);
  yield takeEvery(UPDATE_DEFAULT_ASSIGNMENT, updateDefaultAssignment);
  yield takeEvery(UPDATE_DEFAULT_ASSIGNMENT_STATUS, updateDefaultAssignmentStatus);
  yield takeEvery(DELETE_DEFAULT_ASSIGNMENT, deleteDefaultAssignment);
}

export default defaultAssignmentsSaga;
